import { Field } from 'formik';
import { clsx } from 'clsx';
import { FormControl } from '../../../../shared/components/FormControl/FormControl';
import { Card } from '../../../../card/Card';
import { PipelineSettingsFormFields } from '../../interfaces/pipeline-settings-form-state';
import { FormikAsyncValidatedTextField } from '../../../../input/FormikAsyncValidatedTextField/FormikAsyncValidationTextField';

interface DestinationPartitionKeyProps {
  className?: string;
  disabled?: boolean;
}

export function DestinationPartitionKey({ className, disabled }: DestinationPartitionKeyProps) {
  return (
    <Card
      className={clsx(className)}
      dataId='destination-partition-key'
      gridColumns={2}
      title='Destination Partition Key'
    >
      <div className='grid-column-span-1'>
        <FormControl>
          <Field
            name={PipelineSettingsFormFields.DESTINATION_PARTITION_KEY}
            component={FormikAsyncValidatedTextField}
            label='Destination Partition Key'
            placeholder='Destination Partition Key'
            required
            disabled={disabled}
          />
        </FormControl>
      </div>
    </Card>
  );
}
